<template>
    <button class="moreBu" @click="gotoLink()">查看更多 <span>>></span></button>
</template>

<script>
export default {
    methods:{
        gotoLink(){
            this.$emit('toLink')
        }
    }
}
</script>

<style lang="scss" scoped>
button{
    display: block;
    font-size: vw(18);
    padding: .77rem 2rem;
    cursor: pointer;
    outline: none;
    border: 0;
    border-radius: 8px;
    background: transparent;

    span{
        display: inline-block;
        transition: all .2s linear;
    }

    &:hover{
        span{
            transform: translateX(vw(8));
        }
    }

    // -------------------------------  手机端  -------------------------------

    @media only screen and (max-width: 767px){
        font-size: vp(24);
    }
}
</style>